import React, { memo } from 'react'
import classNames from 'classnames'
import { makeStyles } from 'transfix-ui/core/styles'

const useOptionDescriptionStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flex: '0 0 auto',
    paddingLeft: theme.spacing(1),
  },
}))

interface IOptionDescriptionProps {
  description?: string
  className?: string
}

export const OptionDescription = memo<IOptionDescriptionProps>(
  ({ className: classNameProp = '', description = '' }) => {
    const classes = useOptionDescriptionStyles()
    const className = classNames(classes.root, classNameProp)
    return <div className={className}>{description}</div>
  }
)
